import { ListChecks } from "lucide-react";
import { APP_NAME } from "../config";

/** `iconOnly` hides the name visually (collapsed sidebar); screen readers still hear it. */
export function Logo({ className = "", iconOnly = false }: { className?: string; iconOnly?: boolean }) {
  return (
    <span className={`flex items-center gap-2 text-lg font-bold text-ink ${className}`}>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand text-white">
        <ListChecks size={20} aria-hidden />
      </span>
      <span className={iconOnly ? "sr-only" : ""}>{APP_NAME}</span>
    </span>
  );
}
